import request from '@/utils/request.js'

/***  封装请求方法  ***/
export function wxRequest(url, data, method){
    let obj = {};
    if(method=="get"){
        obj = {
            url: url,
            method: method,
            params: data,
        }
    }else if(method=="post"){
        obj = {
            url,
            method,
            data,
        }
    }
    return request(obj)
}


/***实名认证***/
export function verified(params){

    var formdata = new FormData();
    Object.keys(params).forEach((key) => {
        formdata.append(key, params[key]);
    });
    return request({
        url: 'bindPhone/phone',
        method: 'post',
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: formdata
    })
}

